// extracted by mini-css-extract-plugin
export var ar16x9 = "VideoEmbed-module--ar16x9--acf75";
export var ar1x1 = "VideoEmbed-module--ar1x1--c2766";
export var ar4x3 = "VideoEmbed-module--ar4x3--5d3e2";
export var ar9x16 = "VideoEmbed-module--ar9x16--24fcc";
export var container = "VideoEmbed-module--container--30d26";
export var videoContainer = "VideoEmbed-module--videoContainer--7ad85";